import React, { useEffect } from 'react';
import { CourseLayout } from './layout/CourseLayout';
import { CourseContent, SidebarGroup } from './types';
import SpriteDefs from './SpriteDefs';
import SidebarComponent from './Sidebar';
import { boasVindasSidebar, module1Name } from './boasVindasData';


const sidebar: SidebarGroup[] = boasVindasSidebar;

const content: CourseContent = {
  itemId: '2078932',
  slug: 'boas-vindas',
  secaoId: '426683',
  title: 'Comece por aqui',
  breadcrumbs: [
    { label: 'Início', href: '/vitrine' },
    { label: 'Trading' },
  ],
  video: { platform: 'youtube', videoId: 'Z7AlPkKbRIA' },
  article: [
    'Para começar a Lucrar com Opções Binárias é OBRIGATÓRIO que você crie sua conta na Melhor Corretora através do LINK abaixo.',
    '🔥 Crie sua conta na Melhor Corretora: https://xxbroker.com',
    'Entre no nosso Grupo do Telegram exclusivo para alunos da Trending. Todos os dias de Segunda à Sexta às 10:30 - 12:15 e 19:30 temos LIVES de Operações ao vivo e SINAIS.',
    '🔵 Grupo de Sinais Telegram: http://t.me/trendingbrazil  🔵 Grupo de Avisos Telegram: https://t.me/avisostrending',
    'Queremos preparar o melhor conteúdo possível para nossos alunos, por favor preencha essa pesquisa: https://bit.ly/pesquisa-novo-bc',
    'Siga nosso perfil no instagram para conteúdos e novidades.',
    '🟣 Instagram da Trending: https://bit.ly/insta-trending',
    '🟣 Instagram do Gabriel Moreira Trader: https://instagram.com/Gabriel Moreiratrader',
    '🟣 Instagram do Gabriel Moreira Trader Perfil Reserva: https://www.instagram.com/Gabriel Moreirainvestidor',
  ],
  sidebar,
};

const Sidebar: React.FC = () => {
  return <SidebarComponent sidebar={sidebar} moduleTitle={module1Name} />;
};

const BoasVindas: React.FC = () => {
  useEffect(() => {
    // Habilitar scroll e carregar CSS da vitrine, como na Vitrine
    const previousBodyClass = document.body.className;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;

    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';

    // Garante que o body use as classes do ambiente da área
    document.body.classList.add('area', 'aula', 'netflix', 'area-produto');

    let stylesLink = document.querySelector('link[data-vitrine-styles]') as HTMLLinkElement | null;
    if (!stylesLink) {
      stylesLink = document.createElement('link');
      stylesLink.rel = 'stylesheet';
      stylesLink.href = '/vitrine_assets/styles.css';
      stylesLink.setAttribute('data-vitrine-styles', 'true');
      document.head.appendChild(stylesLink);
    }
    // Garante que, SE o dark.css existir, ele fique DEPOIS do styles.css
    const ensureDarkStylesLast = () => {
      const darkEl = document.getElementById('dark-styles') as HTMLLinkElement | null;
      if (darkEl) {
        document.head.appendChild(darkEl); // move para o final, garantindo prioridade do tema escuro
      }
    };
    ensureDarkStylesLast();

    return () => {
      document.body.className = previousBodyClass;
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
    };
  }, []);

  return (
    <>
      <SpriteDefs />
      <CourseLayout content={content} right={<Sidebar />} />
    </>
  );
};

export default BoasVindas;

